import { useEffect } from "react";
import DataLoader from "../context/dataLoader/DataLoader";

import './Root.scss';
import './Pages.scss';
import Navigator from "./navigator/Navigator";
import SettingsLoader from "../context/settings/SettingsLoader";

//import './Fonts.scss';


function Root() {



    useEffect(() => {
        //
    }, [])


    return <DataLoader>
        <SettingsLoader>
            <div className="chartographer">
                <Navigator />
            </div>
        </SettingsLoader>
    </DataLoader>
}


export default Root;